import { ElementInfo } from "../Models/ElementInfoModel";
import * as OBC from "@thatopen/components";
import { ModelInfo } from "../Models/ModelInfo";

export const Isolate = (ids: ElementInfo[], components: OBC.Components, modelIds: ModelInfo[]) => {
    const hider = components!.get(OBC.Hider);
    const fragments = components!.get(OBC.FragmentsManager);

    hider.set(false);
    ids.forEach((id) => {
        const modelFragmentId = modelIds.find((m) => m.modelId === id.modelId);
        console.log('ModelFragmentIdIsolate:', modelFragmentId, modelIds, id,fragments.modelIdToFragmentIdMap({
            [modelFragmentId?.fragmentId!]: new Set([id.expressId]),
        }));
       
        // hider.set(false);
        hider.set(true,fragments.modelIdToFragmentIdMap({
            [modelFragmentId?.fragmentId!]: new Set([id.expressId]),
        }))
    });
}